import React, { useState } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import Card from '../../../lib/components/Card'

import { ppsSelector } from '../../../selectors'
import { selectMode } from '../model'

import left_arrow from '../../../static/images/left-arrow.svg'

const Layout = {
  Root: styled(Card)`
    --padding-top: 12px;

    width: auto;
    min-width: 380px;
    /* padding: calc(50px + var(--padding-top)) 16px 12px; */
  `,
  Header: styled.div`
    width: 100%;
    height: 50px;
    border: 1px solid #EAEAEA;
    background: #404040;
    cursor: pointer;
    padding-left: 32px;

    display: flex;
    align-items: center;

    position: absolute;
    top: 0;
    left: 0;

    font-family: 'Gotham-Medium';
    font-size: 15px;
    color: #FFFFFF;
  `,
  Container: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 16px;
    column-gap: 40px;
    padding: 16px 12px;
  `,
  Grid: styled.div`
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-gap: 16px;
  `,
}

const Revenue = {
  Title: styled.div`
    margin-bottom: 4px;

    grid-column: span 2;

    color: #333;
    font-family: 'Gotham-Bold';
    font-size: 14px;
    line-height: 16px;
  `,
  Label: styled.div`
    color: #333;
    font-family: 'Gotham';
    font-size: 14px;
    line-height: 16px;
  `,
  Percent: styled.div`
    color: #333;
    font-family: 'Notosans';
    font-size: 14px;
    line-height: 16px;
    text-align: right;
    margin-left: 4px;
  `,
  Value: styled.div`
    color: #333;
    font-family: 'Notosans';
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  `,
  Arrow: styled.img`
    width : 10px;
    height : 10px;
    position: absolute;
    top: 18px;
    left: 0;
    margin: auto 14px;
    cursor: pointer;
  `,
}

/**
 * @typedef {object} Props
 * @property {object} profitData
 * @property {boolean} display
 */

/** @param {Props} props */
function ProjectSummary(props) {
  const [expand, setExpand] = useState(true)

  const { profitData, display } = props

  const mode = selectMode(display)
  const data = {
    summary: {
      project_summary_sga_allocation: profitData[`$${mode}_project_summary_sga_allocation`],
      project_summary_contract_price: profitData[`$${mode}_project_summary_contract_price`],
      project_summary_forecast_cost: profitData[`$${mode}_project_summary_forecast_cost`],
      project_summary_gross_profit: profitData[`$${mode}_project_summary_gross_profit`],
      project_summary_gross_profit_ratio: profitData[`$${mode}_project_summary_gross_profit_ratio`],
      project_summary_oi: profitData[`$${mode}_project_summary_oi`],
      project_summary_oi_ratio: profitData[`$${mode}_project_summary_oi_ratio`],
    },
  }

  return (
    <Layout.Root topic="Project Summary">
      <Layout.Header onClick={ () => setExpand(!expand) }>
        Project Summary
      </Layout.Header>
      <Revenue.Arrow
        style={ {
          transform: expand ? 'rotate(270deg)' : 'rotate(180deg)',
        } }
        src={ left_arrow }
        collapse={ !expand }
        onClick={ () => setExpand(!expand) }
      />
      { expand &&
        <Layout.Container>
          <Layout.Grid>
            <Revenue.Label>Current Price</Revenue.Label>
            <Revenue.Value>{`${data.summary.project_summary_contract_price || '-'}`}</Revenue.Value>
            <Revenue.Label>Forecast Cost</Revenue.Label>
            <Revenue.Value>{`${data.summary.project_summary_forecast_cost || '-'}`}</Revenue.Value>
            <Revenue.Label>GP</Revenue.Label>
            <Revenue.Value>
              {`${data.summary.project_summary_gross_profit || '-'}`}
              <Revenue.Percent>{`(${data.summary.project_summary_gross_profit_ratio || '-'}%)`}</Revenue.Percent>
            </Revenue.Value>
            <Revenue.Label>SGA Allocation</Revenue.Label>
            <Revenue.Value>{`${data.summary.project_summary_sga_allocation || '-'}`}</Revenue.Value>
            <Revenue.Label>OI</Revenue.Label>
            <Revenue.Value>
              {`${data.summary.project_summary_oi || '-'}`}
              <Revenue.Percent>{`(${data.summary.project_summary_oi_ratio || '-'}%)`}</Revenue.Percent>
            </Revenue.Value>
          </Layout.Grid>
        </Layout.Container>
      }
    </Layout.Root>
  )
}

const mapStateToProps = createStructuredSelector({
  profitData: ppsSelector.profitData,
  display: ppsSelector.display,
})

export default connect(
  mapStateToProps,
  null
)(ProjectSummary)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/ProjectSummary.js